<template>
  <div class="modal_container modal_overlay" :class="{ 'model-open': open }">
    <div class="modal_content">
      <div class="modal_title" v-if="is_title">
        <div class="modal_title_text" v-html="title"></div>
        <div class="modal_close" v-if="is_close" @click.prevent="onClose"><i class="fa fa-times" /></div>
      </div>
      <div class="modal_body">
        <slot> <div class="demo_text">Content Area</div> </slot>
      </div>
      <div v-if="$slots?.footer" class="footer_container">
        <slot name="footer"> <div class="demo_text">Footer Area</div> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    is_title: { type: Boolean, default: true },
    is_loading: { type: Boolean, default: false },
    title: { type: String, default: "Default" },
    open: { type: Boolean, default: false }
  },
  computed: {
    is_close() {
      return "onOnClose" in (this?.$options?.propsData || {});
    },
    classes() {
      return this?.$options?.propsData?.class || "";
    }
  },
  methods: {
    onClose() {
      if (this.is_close) {
        this.$emit("on-close");
      }
    }
  }
};
</script>

<style lang="scss">
.modal_container {
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  margin-top: var(--header_height);
  &.modal_overlay {
    position: fixed;
    overflow: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1050;
    background: rgba(0, 0, 0, 0.7);
  }
  &.model-open {
    opacity: 1;
    visibility: visible;
  }
  .modal_content {
    margin: 1.75rem auto;
    background: #fff;
    transform: translate(0);
    width: 90%;
    border-radius: 4px;
    max-width: 920px;
    max-height: 480px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--dp-c-card-background);
    box-shadow: var(--dp-c-card-shadow);
    border: 1px solid var(--dp-c-border-color);
    .modal_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid var(--dp-c-border-color);
      .modal_close {
        color: var(--red-froly);
        cursor: pointer;
      }
    }
    .modal_body {
      padding: 10px;
      .btn {
        padding: 5px 0px;
        width: 80px !important;
        font-size: var(--fnt-12);
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
    .demo_text {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      width: 100%;
    }
    .footer_container {
      padding: 10px 10px;
      border-top: 1px solid var(--bs-gray-800);
      display: flex;
      justify-content: flex-end;
      button {
        font-size: var(--fnt-12);
        width: 85px;
        padding: 4px 10px;
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
  &.mobile {
    .modal_content {
      .modal_title {
        padding: 8px;
        .modal_title_text {
          font-size: var(--fnt-13);
        }
      }
    }
  }
}
</style>